import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    TextField,
    Typography,
    Box,
    makeStyles,
    Chip
} from "@material-ui/core";
import { AcUnit, Whatshot, Brightness5 } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
    dialog: {
        minWidth: 500,
        borderRadius: 12,
        boxShadow: "0px 25px 50px -12px rgba(0, 0, 0, 0.25) !important",
        border: "1px solid rgba(0, 0, 0, 0.05)"
    },
    moveInfo: {
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(2),
        borderRadius: theme.shape.borderRadius,
        marginBottom: theme.spacing(2)
    },
    temperatureOption: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1)
    },
    suggestedChip: {
        marginLeft: theme.spacing(1)
    },
    notesField: {
        marginTop: theme.spacing(2)
    }
}));

const TemperatureModal = ({ open, onClose, onConfirm, fromCard, toCard, opportunityTitle, suggestedTemperature }) => {
    const classes = useStyles();
    const [temperature, setTemperature] = useState("");
    const [notes, setNotes] = useState("");

    useEffect(() => {
        if (open && suggestedTemperature) {
            setTemperature(suggestedTemperature);
        }
    }, [open, suggestedTemperature]);

    const handleConfirm = () => {
        if (!temperature) {
            alert("Por favor, selecione a temperatura do lead");
            return;
        }
        onConfirm({ temperature, notes });
        handleClose();
    };

    const handleClose = () => {
        setTemperature("");
        setNotes("");
        onClose();
    };

    const getTemperatureIcon = (temp) => {
        switch (temp) {
            case "cold":
                return <AcUnit style={{ color: "#2196f3" }} />;
            case "warm":
                return <Brightness5 style={{ color: "#ff9800" }} />;
            case "hot":
                return <Whatshot style={{ color: "#f44336" }} />;
            default:
                return null;
        }
    };

    const getTemperatureLabel = (temp) => {
        switch (temp) {
            case "cold":
                return "🔵 Frio";
            case "warm":
                return "🟡 Morno";
            case "hot":
                return "🔴 Quente";
            default:
                return "";
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
            classes={{ paper: classes.dialog }}
        >
            <DialogTitle>Movendo Lead</DialogTitle>
            <DialogContent>
                <Box className={classes.moveInfo}>
                    <Typography variant="subtitle2" color="textSecondary">
                        Lead
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        <strong>{opportunityTitle}</strong>
                    </Typography>

                    <Typography variant="subtitle2" color="textSecondary" style={{ marginTop: 8 }}>
                        Movimentação
                    </Typography>
                    <Typography variant="body2">
                        De: <strong>{fromCard?.name || "Início"}</strong> → Para: <strong>{toCard?.name}</strong>
                    </Typography>
                </Box>

                <FormControl component="fieldset" fullWidth required>
                    <FormLabel component="legend">Temperatura do Lead *</FormLabel>
                    <RadioGroup
                        value={temperature}
                        onChange={(e) => setTemperature(e.target.value)}
                    >
                        <FormControlLabel
                            value="cold"
                            control={<Radio />}
                            label={
                                <Box className={classes.temperatureOption}>
                                    {getTemperatureIcon("cold")}
                                    <span>{getTemperatureLabel("cold")}</span>
                                    {suggestedTemperature === "cold" && (
                                        <Chip
                                            label="Sugerido"
                                            size="small"
                                            color="primary"
                                            className={classes.suggestedChip}
                                        />
                                    )}
                                </Box>
                            }
                        />
                        <FormControlLabel
                            value="warm"
                            control={<Radio />}
                            label={
                                <Box className={classes.temperatureOption}>
                                    {getTemperatureIcon("warm")}
                                    <span>{getTemperatureLabel("warm")}</span>
                                    {suggestedTemperature === "warm" && (
                                        <Chip
                                            label="Sugerido"
                                            size="small"
                                            color="primary"
                                            className={classes.suggestedChip}
                                        />
                                    )}
                                </Box>
                            }
                        />
                        <FormControlLabel
                            value="hot"
                            control={<Radio />}
                            label={
                                <Box className={classes.temperatureOption}>
                                    {getTemperatureIcon("hot")}
                                    <span>{getTemperatureLabel("hot")}</span>
                                    {suggestedTemperature === "hot" && (
                                        <Chip
                                            label="Sugerido"
                                            size="small"
                                            color="primary"
                                            className={classes.suggestedChip}
                                        />
                                    )}
                                </Box>
                            }
                        />
                    </RadioGroup>
                </FormControl>

                <TextField
                    className={classes.notesField}
                    label="Observações (opcional)"
                    multiline
                    rows={3}
                    fullWidth
                    variant="outlined"
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    placeholder="Adicione observações sobre esta movimentação..."
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="default">
                    Cancelar
                </Button>
                <Button onClick={handleConfirm} color="primary" variant="contained">
                    Confirmar Mudança
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default TemperatureModal;
